import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sun, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { SubjectBadge } from "@/components/SubjectBadge";

export const WordOfTheDay = () => {
  const [term, setTerm] = useState(null);
  useEffect(() => { api.get("/word-of-the-day").then((r) => setTerm(r.data)).catch(() => {}); }, []);
  if (!term) return null;
  return (
    <section className="ink-box rise mb-10 grid overflow-hidden rounded-3xl bg-[var(--sky)] text-white md:grid-cols-[1.4fr_1fr]" data-testid="word-of-the-day">
      <div className="p-7 sm:p-9">
        <span className="ink-box-sm inline-flex items-center gap-2 rounded-full bg-[var(--sun)] px-3 py-1 text-xs font-extrabold uppercase tracking-widest text-[var(--ink)]">
          <Sun className="h-3.5 w-3.5" /> Parola del giorno
        </span>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <h2 className="font-display text-4xl font-bold" data-testid="wotd-word">{term.word}</h2>
          <span className="text-[var(--ink)]"><SubjectBadge subject={term.subject} /></span>
        </div>
        <p className="mt-3 max-w-xl text-base font-semibold text-white/90 md:text-lg" data-testid="wotd-definition">{term.definition}</p>
        <Link to={`/termine/${term.id}`} data-testid="wotd-open-link" className="ink-box-sm ink-press mt-6 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2 font-extrabold text-[var(--ink)]">
          Scoprila <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      {term.comic_status === "ready" ? (
        <img src={mediaUrl(term.comic_path)} alt={`Fumetto: ${term.word}`} className="h-full max-h-80 w-full border-t-[2.5px] border-[var(--ink)] object-cover md:border-l-[2.5px] md:border-t-0" />
      ) : (
        <div className="font-comic hidden items-center justify-center border-l-[2.5px] border-[var(--ink)] bg-[var(--sun)] p-8 text-center text-5xl text-[var(--ink)] md:flex">WOW!<br />UNA PAROLA NUOVA!</div>
      )}
    </section>
  );
};
